export enum DocumentType {
  PrivacyNotesForRegistration = "PrivacyNotesForRegistration",
  LegalInformationForDepragGoldPurchase = "LegalInformationForDepragGoldPurchase",
  PreReleaseSoftware = "PreReleaseSoftware"
}
